import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { LearnComponent } from "./learn/learn.component";
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { LearnRoutingModule } from './learn-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LearnByCourseComponent } from './learn-by-course/learn-by-course.component';
import { MyclassComponent } from './myclass/myclass.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MySessionsComponent } from './my-sessions/my-sessions.component';
import { AddAttendanceComponent } from './myclass/add-attendance/add-attendance.component';

@NgModule({
    imports: [
        CommonModule,
        LearnRoutingModule,
        NgxChartsModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        MatchHeightModule,
        NgxSpinnerModule,
        NgxDatatableModule, 
        NgSelectModule
    ],
    declarations: [
        LearnComponent,
        LearnByCourseComponent,
        MyclassComponent,
        MySessionsComponent,
        AddAttendanceComponent
    ]
})
export class LearnModule { }
